import React from 'react';
import './Stats.css';
import statsData from '../data/stats.json';

const Stats = () => {
  const { stats } = statsData;

  return (
    <section className="stats">
      <div className="stats-container">
        {stats.map((stat) => (
          <div key={stat.id} className="stat-item">
            <h3 className="stat-number">{stat.number}</h3>
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
